export default "__VITE_ASSET__Be3BTPFV__"